import React from 'react';
import { Clock, Sparkles, Instagram, MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from '../lib/trackWhatsApp';

const PricingSection = () => {
  const pricingData = [
    {
      service: 'Acrylic Extensions + Gel Polish',
      note: 'solid colour',
      happyPrice: '₹1999',
      regularPrice: '₹2999',
      discount: '33% OFF',
      savings: 'Save ₹1000',
    },
    {
      service: 'Gel Extensions + Gel Polish',
      note: 'solid colour',
      happyPrice: '₹1899',
      regularPrice: '₹2799',
      discount: '32% OFF',
      savings: 'Save ₹900',
    },
    {
      service: 'Gel Polish',
      note: 'solid colour',
      happyPrice: '₹599',
      regularPrice: '₹999',
      discount: '40% OFF',
      savings: 'Save ₹400',
    },
    {
      service: 'Gel Polish (Hands & Legs)',
      note: 'solid colour',
      happyPrice: '₹1099',
      regularPrice: '₹1999',
      discount: '45% OFF',
      savings: 'Save ₹900',
    },
    {
      service: 'Cat Eye Polish',
      happyPrice: '₹1499',
      regularPrice: '₹2499',
      discount: '40% OFF',
      savings: 'Save ₹1000',
    },
    {
      service: 'French Nails',
      happyPrice: '₹1499',
      regularPrice: '₹2499',
      discount: '40% OFF',
      savings: 'Save ₹1000',
    },
  ];

  const handleInstagram = () => {
    window.open('https://www.instagram.com/o2nails_hyd/', '_blank');
  };

  const handleWhatsApp = () => {
    trackWhatsAppClick({ openInNewTab: true, location: 'pricing' });
  };

  return (
    <section className="pricing-section">
      <div className="pricing-container">
        <div className="pricing-header">
          <div className="happy-hour-badge">
            <Sparkles className="sparkle-icon" />
            <span>Happy Hour Specials</span>
            <Sparkles className="sparkle-icon" />
          </div>
          <p className="happy-hour-timing-top">10:30 AM – 4 PM, All Days</p>
          
          <div className="social-buttons-pricing">
            <button 
              onClick={handleWhatsApp}
              className="social-btn-pricing whatsapp"
              aria-label="Chat with us on WhatsApp"
            >
              <MessageCircle className="social-btn-icon" />
              <span>Chat with Us Instantly</span>
            </button>
          </div>
        </div>

        <div className="pricing-grid">
          {pricingData.map((item, index) => (
            <div key={index} className="pricing-card">
              <h3 className="service-name">
                {item.service}
                {item.note && <span className="service-note">({item.note})</span>}
              </h3>
              
              {/* Discount percentage - prominent */}
              <div className="discount-percentage">{item.discount}</div>
              
              <div className="price-display">
                <span className="happy-price">{item.happyPrice}</span>
                <span className="regular-price">{item.regularPrice}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="pricing-footer">
          <div className="happy-hour-timing">
            <Clock className="clock-icon-footer" />
            <span className="timing-text">Happy Hour: 10:30 AM – 4 PM (All Days)</span>
          </div>
          <p className="regular-price-note">
            *Regular prices apply outside Happy Hour timings
          </p>
          <p className="additional-services-note">
            Looking for something else? We offer luxury manicures, pedicures, custom extensions, ombre blends, and bespoke nail art. Speak with our nail experts to design something uniquely yours.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
